import { LESSON_PREVIEWS_GROUP } from "@/graphql/queries/lessons";
import { useLazyQuery } from "@apollo/client";
import { createContext, useContext, useState } from "react";

const LessonsContext = createContext(null);

export function LessonsProvider({ children }) {
    const [lessonPreviews, setLessonPreviews] = useState([]);

    return (
        <LessonsContext.Provider value={[lessonPreviews, setLessonPreviews]}>
            {children}
        </LessonsContext.Provider>
    );
}

export default function useLessons({ courseId }) {
    courseId = parseInt(courseId);
    const [lessonPreviews, setLessonPreviews] = useContext(LessonsContext);

    const [getLessonPreviews, { loading }] = useLazyQuery(
        LESSON_PREVIEWS_GROUP
    );

    const _getLessonPreivews = (groupId) => {
        getLessonPreviews({
            variables: {
                groupId: groupId,
                courseId: courseId,
            },
        }).then((result) => {
            const previews = result?.data?.lessonPreviewsGroup?.previews ?? [];
            // Force a new array reference to ensure React detects the change
            setLessonPreviews([...previews]);
        });
    };

    const _getActiveLessonPreview = () => {
        const coppiedLessonPreviews = lessonPreviews?.map((i) => i);
        coppiedLessonPreviews.sort((a, b) =>
            parseInt(a.lessonNumber) < parseInt(b.lessonNumber) ? -1 : 1
        );

        let activeLessonPreview;
        for (const lp of coppiedLessonPreviews) {
            if (lp?.probablyActive?.isActive == false) {
                break;
            }
            activeLessonPreview = lp;
        }

        return activeLessonPreview;
    };

    const _isLatestLessonOfGroup = (lessonNumber) => {
        let coppied = [...lessonPreviews];
        coppied.sort((a, b) => {
            if (a.lessonNumber < b.lessonNumber) return -1;
            return 1;
        });
        let latest = coppied?.[coppied?.length - 1];
        return String(latest.lessonNumber) == String(lessonNumber);
    };

    return {
        lessonPreviews,
        loading,

        getActiveLessonPreview: _getActiveLessonPreview,
        getLessonPreviewByNumber: function (lessonNumber) {
            return (
                lessonPreviews?.find(
                    (l) => parseInt(l.lessonNumber) === parseInt(lessonNumber)
                ) ?? null
            );
        },

        getLessonPreviews: _getLessonPreivews,
        isLatestLessonOfGroup: _isLatestLessonOfGroup,
    };
}
